<template>
  <v-app>
    <div class="background" style="height:100%">
      <router-view></router-view>
    </div>
    <demo-mode-dialog></demo-mode-dialog>
  </v-app>
</template>

<script>
import Vue from "vue";
import i18n from "@/utils/translations";
import DemoModeDialog from "@/components/DemoModeDialog";
import { mapState, mapGetters } from "vuex";

export default {
  name: "App",
  data: () => ({}),

  components: { DemoModeDialog },

  created() {
    Vue.moment.locale(i18n.locale);
  },
  computed: {
    ...mapGetters(["getDemoModeDialog"]),
  },
  methods: {
    setAccessToken(token) {
      this.accessToken = token;
    },
  },
};
</script>
